import React from 'react';

import * as styles from './index.module.scss';
import { Row, Col } from 'antd';
import HoverLinkItem from './hoverLink';
import CopyButton from './copiedButton';
import useIsMobile from '../../../hooks/useIsMobile';
import LINKS from '../../../constants';

const Entry = () => {
  const isMobile = useIsMobile();
  const links = [
    {
      img: 'https://cdn-web.mtt.xyz/static/Subtract.png',
      link: LINKS.TELEGRAM,
      icon: 'https://cdn-web.mtt.xyz/static/Artboard.png',
      label: 'Telegram',
    },
    {
      img: 'https://cdn-web.mtt.xyz/static/Subtract%20(1).png',
      link: LINKS.DISCORD,
      icon: 'https://cdn-web.mtt.xyz/static/Subtract%20(4).png',
      label: 'Discord',
    },
    {
      img: 'https://cdn-web.mtt.xyz/static/Subtract%20(2).png',
      link: LINKS.X,
      icon: 'https://cdn-web.mtt.xyz/static/Subtract%20(5).png',
      label: 'Twitter',
    },
    {
      img: 'https://cdn-web.mtt.xyz/static/Subtract%20(3).png',
      link: '',
      icon: 'https://cdn-web.mtt.xyz/static/Subtract%20(6).png',
      label: 'Youtube',
    },
  ];

  return (
    <div className={styles.entry}>
      <div className={styles.srcondBg}>
        <div className={styles.section}>
          <Row
            className={styles.content}
            justify={{
              xxl: 'space-between',
              xl: 'space-between',
              lg: 'center',
            }}
            gutter={[0, 24]}
          >
            <Col
              className={styles.left}
              xl={{ flex: '62%' }}
              lg={{ flex: '100%' }}
              md={{ flex: '100%' }}
              xs={{ flex: '100%' }}
            >
              <div className={styles.title}>
                Third-party development, Businesscooperation, and onboarding
                consulting,etc.
              </div>

              <section className={styles.copiedContent}>
                <div className={styles.label}>Send email to this address</div>
                <div className={styles.item}>
                  <label>support@mtt.network</label>
                  <CopyButton textToCopy="support@mtt.network" />
                </div>
              </section>
            </Col>
            <Col
              className={styles.right}
              xl={{ flex: '35%' }}
              lg={{ flex: '100%' }}
              md={{ flex: '100%' }}
              xs={{ flex: '100%' }}
            >
              <div className={styles.title}>
                Join the
                <br /> MTT Network Community
              </div>
              <div className={styles.links}>
                {links.map(({ img, link, icon, label }, index) => {
                  return (
                    <HoverLinkItem
                      key={index + 'hoverItem'}
                      img={img}
                      link={link}
                      icon={icon}
                      label={label}
                    />
                  );
                })}
              </div>
            </Col>
          </Row>
        </div>
      </div>
    </div>
  );
};

export default Entry;
